import { ShareIcon } from '@heroicons/react/24/outline';
import { ShareIcon as ShareIconSolid } from '@heroicons/react/24/solid';
import { SVGProps } from 'react';

interface DependenciesIconProps extends SVGProps<SVGSVGElement> {
  variant?: 'outline' | 'filled';
}

export function DependenciesIcon({
  className = '',
  variant = 'outline',
  'aria-hidden': ariaHidden = true,
  ...props
}: DependenciesIconProps) {
  // Simple MVP: filled for all visible, outline for others
  const IconComponent = variant === 'filled' ? ShareIconSolid : ShareIcon;
  return <IconComponent className={`${className} rotate-90`} aria-hidden={ariaHidden} {...props} />;
}
